module.exports = __webpack_public_path__ + "img/andrey.66133852.webp";